import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const ServiceNowIcon: FC<IconProps> = ({ ...props }) => (
  <BaseIcon {...props} viewBox="0 0 181 50">
    <g id="surface1">
      <path
        style={{
          stroke: 'none',
          fillRule: 'evenodd',
          fill: 'rgb(16.078431%,24.313725%,25.098039%)',
          fillOpacity: 1,
        }}
        d="M 0.167969 48.820312 L 0.167969 1.203125 L 12.464844 1.203125 L 12.464844 4.992188 C 16.132812 1.914062 20.980469 0.136719 25.828125 0.136719 C 32.09375 0.136719 38.125 2.976562 42.265625 7.835938 C 45.457031 11.625 47.113281 16.363281 47.113281 24.535156 L 47.113281 48.820312 L 34.34375 48.820312 L 34.34375 23.589844 C 34.695312 20.273438 33.75 17.074219 31.625 14.585938 C 29.613281 12.808594 27.128906 11.863281 24.410156 11.980469 C 19.917969 12.097656 15.660156 14.230469 12.9375 17.785156 L 12.9375 48.820312 "
      />
      <path
        style={{
          stroke: 'none',
          fillRule: 'evenodd',
          fill: 'rgb(50.588235%,70.980392%,63.137255%)',
          fillOpacity: 1,
        }}
        d="M 79.75 41.949219 C 76.085938 42.066406 72.535156 40.527344 69.933594 37.921875 C 67.332031 35.316406 65.914062 31.761719 65.914062 28.089844 C 65.675781 22.996094 68.277344 18.140625 72.652344 15.535156 C 77.03125 12.808594 82.585938 12.808594 86.960938 15.535156 C 91.335938 18.140625 93.820312 22.996094 93.585938 28.089844 C 93.703125 31.761719 92.285156 35.316406 89.683594 37.921875 C 87.082031 40.648438 83.535156 42.066406 79.75 41.949219 Z M 79.75 0.136719 C 68.398438 0.136719 58.109375 7.125 53.972656 17.667969 C 49.714844 28.328125 52.316406 40.410156 60.59375 48.226562 C 62.605469 50.121094 65.679688 50.359375 67.804688 48.703125 C 74.785156 43.371094 84.480469 43.371094 91.457031 48.703125 C 93.703125 50.359375 96.660156 50.121094 98.667969 48.226562 C 106.828125 40.410156 109.546875 28.445312 105.410156 17.785156 C 101.269531 7.242188 91.101562 0.253906 79.75 0.136719 Z M 79.75 0.136719 "
      />
      <path
        style={{
          stroke: 'none',
          fillRule: 'evenodd',
          fill: 'rgb(16.078431%,24.313725%,25.098039%)',
          fillOpacity: 1,
        }}
        d="M 132.488281 48.820312 L 123.027344 48.820312 L 104.109375 1.203125 L 116.761719 1.203125 L 127.167969 28.445312 L 137.335938 1.203125 L 147.859375 1.203125 L 157.910156 28.445312 L 168.316406 1.203125 L 180.96875 1.203125 L 162.167969 48.820312 L 152.707031 48.820312 L 142.539062 21.695312 Z M 132.488281 48.820312 "
      />
    </g>
  </BaseIcon>
);
